/* 
 * Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
 * Distributed under the TruVideo proprietary license. 
 */
import apiClient from '../api/client';

export const authService = {
  /**
   * Forgot Password — POST /api/auth/forgot-password
   * Always returns 200 regardless of whether the email exists (anti-enumeration).
   * @param {string} email
   */
  forgotPassword: async (email) => {
    return apiClient.post('/auth/forgot-password', { email });
  },

  /**
   * Validate Reset Token — GET /api/auth/validate-reset-token
   * @param {string} token - Raw token to validate
   */
  validateResetToken: async (token) => {
    const response = await apiClient.get(`/auth/validate-reset-token?token=${encodeURIComponent(token)}`);
    return response.data;
  },

  /**
   * Reset Password — POST /api/auth/reset-password
   * @param {string} token  - Raw token from the reset link query param
   * @param {string} newPassword
   * @param {string} confirmPassword
   */
  resetPassword: async (token, newPassword, confirmPassword) => {
    return apiClient.post('/auth/reset-password', { token, newPassword, confirmPassword });
  },
};
